// GETTERS
export const GET_GLOBAL_MESSAGE = 'GET_GLOBAL_MESSAGE';
// ACTIONS
export const FETCH_COMPANY_LOGO = 'FETCH_COMPANY_LOGO';
// MUTATIONS
export const SET_GLOBAL_MESSAGE = 'SET_GLOBAL_MESSAGE';
export const RESET_GLOBAL_MESSAGE = 'RESET_GLOBAL_MESSAGE';
export const RESET_ALL_STATE = 'reset';
export const SET_CURRENCY_MAP = 'SET_CURRENCY_MAP';
